import { Component, Input, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { DataVersionService } from 'src/app/services/data-version.service';
import { NumericKeyValueState } from 'src/app/_models/state/optionUIState';
import { RouteState } from 'src/app/_models/state/routeState';
@Component({
  selector: 'app-show-data-version',
  templateUrl: './show-data-version.component.html',
  styleUrls: ['./show-data-version.component.scss'],
})
export class ShowDataVersionComponent {
  @Input() route: RouteState;
  dataVersions: NumericKeyValueState[] = [];
  constructor(
    private authenticationService: AuthenticationService,
    private dataversionService: DataVersionService
  ) {
    this.dataVersions = this.dataversionService.getDataVersionList();
  }

  getDataVersionDisplay(value) {
    let version = [];
    const currentVersion = this.dataVersions?.find(function (item) {
      return item.value === 'current';
    });
    if (!value) {
      value = this.authenticationService.currentUserValue?.dataset;
    }
    if (value === 'PCM_NA') {
      value = currentVersion?.value;
    }

    version = this.dataVersions
      ? this.dataVersions.filter((data) => {
          return data.value === value;
        })
      : [];

    return version[0]?.display ? version[0]?.display : value;
  }
}
